/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

const MERMAID_LANGUAGE_ALIASES = new Set(['mermaid', 'mmd']);

const MERMAID_START_RE =
  /^\s*(?:(?:flowchart|graph)\s+(?:TB|TD|BT|RL|LR)\b|(?:sequenceDiagram|classDiagram(?:-v2)?|stateDiagram(?:-v2)?|erDiagram|journey|gantt|pie|mindmap|timeline|gitGraph|quadrantChart|requirementDiagram|C4Context|C4Container|C4Component|C4Dynamic|sankey-beta|xychart-beta|block-beta|packet-beta)\b)/i;

const FENCE_RE = /^\s*```/;

export function isMermaidLanguage(language: string | undefined | null): boolean {
  return MERMAID_LANGUAGE_ALIASES.has(String(language || '').trim().toLowerCase());
}

export function isMermaidStartLine(line: string): boolean {
  return MERMAID_START_RE.test(line);
}

export function normalizeMermaidMarkdown(content: string): string {
  const source = String(content || '');
  if (!source.trim()) return source;

  const lines = source.split(/\r?\n/);
  const normalized: string[] = [];
  let inFence = false;

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];

    if (FENCE_RE.test(line)) {
      normalized.push(line);
      inFence = !inFence;
      continue;
    }

    if (!inFence && isMermaidStartLine(line)) {
      const block: string[] = [];
      let cursor = index;

      while (cursor < lines.length && lines[cursor].trim() !== '') {
        block.push(lines[cursor]);
        cursor += 1;
      }

      normalized.push('```mermaid', ...block, '```');
      index = cursor - 1;
      continue;
    }

    normalized.push(line);
  }

  return normalized.join('\n');
}
